module.exports = __webpack_public_path__ + "img/dark_brown.b43f652c.svg";